import { Game, GameKind, WordleConfiguration } from "../../gql/graphql";

export type WordleGame = Omit<Game, "configuration"> & {
  configuration: WordleConfiguration;
};
export function isWordleGame(game?: Game | null): game is WordleGame {
  return game?.kind === GameKind.Wordle;
}
